const result = {
    possibleTypes: {
        Entity: [
            'User',
            'UserMetadata',
            'Team',
            'ConversationAlias',
            'Conversation',
            'MessageBlobRef',
            'PortalBlobRef',
            'BlobUserInteractions',
            'FileRef',
            'SystemMessage',
            'SMSMetadata',
            'Message',
            'SharedConversationParticipant',
            'ConversationParticipant',
            'MatterInvoiceUserInteractions',
            'IntakeUserInteractions',
            'EventUserInteractions',
        ],
    },
};
export default result;
